(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart-tabs')) {
  class SizeChartTabs extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', this.onClick, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    onClick = (event) => {
      const button = event.target.closest('[role="tab"]');

      if (!button || !this.contains(button)) {
        return;
      }

      const buttons = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const index = buttons.indexOf(button);

      buttons.forEach((tab, tabIndex) => {
        tab.setAttribute('aria-selected', tabIndex === index ? 'true' : 'false');
      });

      panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });
    };
  }

  customElements.define('size-chart-tabs', SizeChartTabs);
}
  } catch(e) { console.error(e); }
})();

})();
